import React, {useEffect, useState, useMemo} from 'react';
import ReactRadarChart from 'react-svg-radar-chart';
import 'react-svg-radar-chart/build/css/index.css';
import cx from './index.module.scss';
import {chartColumnsExcludedIndexes, getDescriptionByTitle, getRadarChartColumns} from '../../assets/columns.data';

const captions = getRadarChartColumns()
  .map(({title, category}, index) => title)
  .reduce((prev, title, index) => ({
    ...prev,
    [index]: title,
  }), {});

const CHART_MIN_WIDTH = 335;
const CHART_MAX_WIDTH = 480;
const INITIAL_TOOLTIP = {
  target: null,
  description: null,
};

const RadarChart = ({company}) => {
  const [chartWidth, setChartWidth] = useState(Math.max(CHART_MIN_WIDTH, Math.min(window.innerWidth * .85, CHART_MAX_WIDTH)));
  const [tooltip, setTooltip] = useState(INITIAL_TOOLTIP);

  const options = useMemo(() => ({
    scales: 5,
    dots: true,
    captionProps: ({caption}) => ({
      className: tooltip.target === caption ? `${cx.caption} ${cx.isActive}` : cx.caption,
      textAnchor: 'middle',
      fontSize: chartWidth < CHART_MAX_WIDTH ? 11 : 12,
      fontFamily: 'sans-serif',
      onMouseEnter: () => {
        setTooltip({
          target: caption,
          description: getDescriptionByTitle(caption),
        });
      },
      onMouseLeave: () => {
        setTooltip(INITIAL_TOOLTIP);
      }
    }),
    shapeProps: () => ({ className: cx.shape }),
    dotProps: () => ({ className: cx.dot }),
  }), [setTooltip, chartWidth, tooltip.target]);

  useEffect(() => {
    const handleResize = () => setChartWidth(Math.min(window.innerWidth * .85, CHART_MAX_WIDTH));
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [setChartWidth]);

  const data = useMemo(() => {
    const {id, name, users, year, total, ...rests} = company;
    const data = Object.keys(rests)
      .filter(item => chartColumnsExcludedIndexes.indexOf(Number(item)) === -1)
      .reduce((prev, key, index) => ({
        ...prev,
        [index]: rests[key] / 100,
      }), {});
    return [{
      data,
      meta: { color: '#E21B23' }
    }]
  }, [company]);

  return chartWidth ? (
    <div className={cx.wrap}>
      <ReactRadarChart
        captions={captions}
        data={data}
        size={chartWidth}
        options={options}
      />
      {tooltip.description && <div className={cx.tooltip}>{tooltip.description}</div>}
    </div>
  ) : null
};

export default RadarChart;
